export default {
  computed: {
    formfields () {
      return [
        {
          text: 'Sequência',
          value: 'sequencia',
          required: true
        },
        {
          text: 'Título',
          value: 'titulo',
          required: true
        },
        {
          text: 'Subtítulo',
          value: 'subtitulo',
          required: true
        },
        {
          text: 'Descrição',
          value: 'descricao',
          required: true
        },
        {
          text: 'Ícone',
          value: 'icone',
          required: true
        },
        {
          text: 'Aplicação',
          value: 'aplicacao',
          select: [
            { text: 'crm', value: 'crm' },
            { text: 'webmobile', value: 'webmobile' }
          ]
        },
        {
          text: 'Ativo',
          value: 'ativo',
          select: [
            { text: 'Sim', value: 'S' },
            { text: 'Não', value: 'N' }
          ]
        }
      ]
    }
  }
}
